import React, { useState } from 'react'
import {FaBars, FaTimes} from "react-icons/fa"
import {Link} from "react-scroll";
import DarkMode from './DarkMode';
const NavBar = () => {
  const [nav, setNav] = useState(false);
  const links = [
    {
      id: 1, 
      link: 'home'
    },
    {
      id: 2, 
      link: 'about'
    },
    {
      id: 3, 
      link: 'portfolio'
    },
    {
      id: 4, 
      link: 'experience'
    },
    {
      id: 5, 
      link: 'contact'
    }
  ]
  const closeNav=()=>{
    setNav(false)
  }
  return (
<div className="flex justify-between items-center w-full h-20 text-gray-800 dark:bg-gray-800 px-4 bg-gray-400  fixed" >
    <div>
        <h1 className='font-signature ml-2 text-5xl cursor-pointer dark:text-gray-200'><Link to="home">Satyam</Link></h1>
    </div>
    <div className="flex justify-center items-center gap-2">
    <ul className="hidden md:flex">
    {links.map(({id, link})=> (
<li key={id} className="px-4 capitalize text-lg text-gray-800 hover:scale-105 duration-200 dark:text-gray-200">
  <Link to={link} smooth duration={500} className="cursor-pointer"offset={-80}>{link}</Link></li>

    ))}
</ul>
<div onClick = {()=>setNav(!nav)} className="cursor-pointer text-gray-800 dark:text-gray-200 pr-4 z-10 md:hidden">
  {nav ? <FaTimes size={30}/> : <FaBars size={30}/> }
  
</div> 
{nav && (
<ul className="flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-gray-200 to-gray-300 text-gray-800 dark:bg-gradient-to-b dark:from-gray-700 dark:to-gray-800 "> 
{links.map(({id, link})=> (
<li key= { id } className="px-4 cursor-pointer capitalize text-2xl text-gray-800 dark:text-gray-200 hover:scale-105 duration-200 m-2"><Link to={link} smooth duration={500} onClick={closeNav}>{link}</Link></li>

    ))}
</ul>
)}
<DarkMode/>
</div>
</div>
  )
}

export default NavBar